import { createStyle } from '@gluestack-style/react';

export const FormControlError = createStyle({
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  width: '100%',
  maxWidth: '100%',
  mt: '$1',
  gap: '$1',
});
